const baseStyle = {
  helper: {
    ml: '8px',
    fontWeight: 400,
    lineHeight: 1,
  },
}

const defaultProps = {}

const sizes = {}

const variants = {}

const parts = ['helper']

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
